import { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HostBackend } from '../HostBackend.js';
import { GetHeaders } from '../../Components/Admin/Functions/FetchHeaders.js';
import { FilterParkAndUnivers } from '../../Components/Public/Filters/FilterParkAndUnivers.js';
import { Origins } from '../../Pages/Public/Origins.js';
import { Origin } from '../../Pages/Public/Origin.js';
import { NotFound } from '../../Pages/Public/NotFound.js';

export const RouteOrigins = () => {
    const backend = HostBackend();
    const guest = sessionStorage.getItem('guest');
    const [parks, setParks] = useState([]);
    const [att, setAtt] = useState([]);
    const [cha, setCha] = useState([]);
    const [ori, setOri] = useState([]);
    useEffect(() => {
        const fetchData = async () => {
            const datasParks = await fetch(`${backend}/nav/parks`, GetHeaders(guest));
            const parks = await datasParks.json();
            setParks(parks);
            const dataAtt = await fetch(`${backend}/nav/attractions`, GetHeaders(guest));
            const att = await dataAtt.json();
            setAtt(att);
            const dataCha = await fetch(`${backend}/nav/characters`, GetHeaders(guest));
            const cha = await dataCha.json();
            setCha(cha);
            const dataOri = await fetch(`${backend}/nav/origins`, GetHeaders(guest));
            const ori = await dataOri.json();
            setOri(ori);
        };
        fetchData();
    }, [backend, guest]);
    if (parks.err) window.location.href = '/';
    const navParks = FilterParkAndUnivers(parks);
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/films-et-series" element={<Origins navParks={navParks} ori={ori} att={att} cha={cha} />} />
                {ori.map((el, i) => {
                    return (<Route path={el.oroute} element={<Origin navParks={navParks} id={el.oid} />} key={i} />)
                })}
                <Route path="*" element={<NotFound navParks={navParks} />} />
            </Routes>
        </BrowserRouter>
    )
}